// extracted by mini-css-extract-plugin
export default {"nav":"SettingsNav_nav__cM-t-","title":"SettingsNav_title__XapSu","item":"SettingsNav_item__mWsry","itemActive":"SettingsNav_itemActive__cpAcQ"};